/* eslint-disable max-len */
import {
  Dropdown, MenuProps, Tag, Modal, message, Popover, ConfigProvider,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import bizGlobal from 'src/redux/action/bizGlobal';
import { useInterval } from 'ahooks';
import logo from 'src/images/logo.png';
import defaultPic from 'src/images/defaultPic.png';
import { isEmpty } from 'lodash';
import IconBass from 'src/components/IconBass';
import { usePost } from 'src/hooks/useFetch';
import { getOrderResult } from 'src/apis/order';
import lessStyle from './index.module.less';

const { GET_ACCOUNT_TYPE, GET_RECHARGE_VISIBLE, GET_ACCOUNT_BALANCE } = bizGlobal;

const menuItemsMap: any = {
  'realEstate:tab:queryList': {
    label: '查询列表',
    key: 'search',
    path: '/admin/search',
  },
  'realEstate:tab:userManage': {
    label: '用户管理',
    key: 'useManagement',
    path: '/admin/useManagement',
  },
  'realEstate:tab:contractManage': {
    label: '合同管理',
    key: 'contractManagement',
    path: '/admin/contractManagement',
  },
  'realEstate:tab:balanceManage': {
    label: '余额管理',
    key: 'balanceManagement',
    path: '/admin/balanceManagement',
  },
};

const priceBalanceMap: any = {
  10: '900元',
  20: '1200元',
  30: '1500元',
};

const prodList: any[] = [
  { key: 'p50000', name: '尊享大额包', price: 50000, give: 6000, per: 1071, test: 0.04 },
  { key: 'p20000', name: '超值优惠包', price: 20000, give: 2000, per: 1091, test: 0.03 },
  { key: 'p10000', name: '基础常用包', price: 10000, give: 800, per: 1111, test: 0.02 },
  { key: 'p2000', name: '小额体验包', price: 2000, give: 0, per: 1200, test: 0.01 },
];

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const todo = searchParams.get('todo');
  const [activeMenu, setActiveMenu] = useState('');
  const [activeProd, setActiveProd] = useState('p50000');
  const [rechargeSuccess, setRechargeSuccess] = useState(false);
  const [popOpen, setPopOpen] = useState(false);
  const [orderDetail, setOrderDetail] = useState<any>({});
  const [interResult, setInterResult] = useState<number | undefined>(undefined);
  const [count, setCount] = useState(5);
  const [interSuccess, setInterSuccess] = useState<number | undefined>(undefined);

  const bizGlobalReducers = useSelector((state: any) => state.bizGlobalReducers || {});
  const { authInfo = {}, menusAuth = [], accountBalance = {}, accountType, rechargeVisible } = bizGlobalReducers;
  const menuItems = useMemo(() => menusAuth?.map((item: any) => menuItemsMap?.[item.access]), [menusAuth]);
  const showZhanghuyue = useMemo(() => {
    // 律所管理员
    if (accountType === 'office' && authInfo?.roleType === 1) {
      return true;
    }
    // 个人账户、角色为普通用户、已完成律师认证
    if (accountType === 'person' && authInfo?.statusCode === 5) {
      return true;
    }
    return false;
  }, [authInfo, accountType]);

  const setRechargeVisible = (visible: boolean) => {
    dispatch<any>(GET_RECHARGE_VISIBLE(visible));
  };

  const { fetchData: createOrder } = usePost('/oa-real-estate/api/v1/pay/create/order/ali');

  useInterval(() => {
    if (orderDetail?.outTradeNo) {
      getOrderResult(orderDetail.outTradeNo).then((res: any) => {
        if (res?.data?.payStatus === 1) {
          dispatch<any>(GET_ACCOUNT_BALANCE());
          setInterResult(undefined);
          setRechargeSuccess(true);
          setInterSuccess(1000);
        }
      });
    }
  }, interResult);

  useInterval(() => {
    setCount(count - 1);
  }, interSuccess);

  const goSearch = () => {
    navigate('/admin/search');
  };

  useEffect(() => {
    if (count <= 0) {
      setInterSuccess(undefined);
      setCount(5);
      setRechargeVisible(false);
      goSearch();
    }
  }, [count]);

  const showRecharge = () => {
    // setPopOpen(false);
    // setRechargeSuccess(false);
    // setRechargeVisible(true);
    window.open('/#/admin/recharge', '_blank');
  };

  const activeProdDetail = useMemo(() => {
    const activeItem = prodList.find((item: any) => item.key === activeProd);
    return activeItem || null;
  }, [activeProd]);

  useEffect(() => {
    setOrderDetail({});
    setInterResult(undefined);
    if (activeProdDetail && rechargeVisible && !rechargeSuccess) {
      createOrder({
        amount: activeProdDetail.price,
        body: activeProdDetail.name,
      }).then((res: any) => {
        setOrderDetail(res.data);
      });
    }
  }, [activeProdDetail, rechargeVisible, rechargeSuccess]);

  useEffect(() => {
    if (orderDetail?.qrCodePath && orderDetail?.outTradeNo) {
      setInterResult(2000);
    }
  }, [orderDetail]);

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes('/admin/rechargeRecordSystem') || currentPath.includes('/admin/deductionRecordSystem')) {
      setActiveMenu('balanceManagement');
    } else {
      const activeItem = menuItems.find((item: any) => currentPath.includes(item.key));
      if (activeItem) {
        setActiveMenu(activeItem.key);
      } else {
        setActiveMenu('');
      }
    }
  }, [location.pathname, menuItems]);

  const isAccountAuth = useMemo(() => {
    return location.pathname === '/admin/account-auth';
  }, [location.pathname]);

  const handleMenuClick = (item: typeof menuItems[0]) => {
    setActiveMenu(item.key);
    navigate(item.path);
  };

  const handleProfileClick = () => {
    navigate('/admin/userProfile');
  };

  const handleLogoutClick = () => {
    Modal.confirm({
      title: '确认退出登录',
      content: '您确定要退出当前账号吗？',
      centered: true,
      onOk: () => {
        // 清除用户登录信息，例如从 localStorage 中删除 token
        localStorage.removeItem('token');
        message.success('退出登录成功');
        // 跳转到登录页面
        const systemType = localStorage.getItem('systemType');
        navigate(`/login${systemType ? `?systemType=${systemType}` : ''}`);
      },
      okText: '确认',
      cancelText: '取消',
    });
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      label: '个人中心',
      onClick: handleProfileClick,
    },
    {
      key: 'logout',
      label: '退出登录',
      onClick: handleLogoutClick,
    },
  ];

  const switchAccountType = (type: string) => {
    if (accountType !== type) {
      dispatch<any>(GET_ACCOUNT_TYPE(type));
      let newUrl = null;
      if (window.location.href.includes('/admin/authentication')) {
        // 认证流程页面分为了三类，切换账号是需要处理
        if (type === 'person') {
          newUrl = `${window.location.origin}/#/admin/authenticationPerson${todo ? `?todo=${todo}` : ''}`;
        } else if (type === 'office') {
          if (authInfo?.roleType === 0) {
            newUrl = `${window.location.origin}/#/admin/authentication${todo ? `?todo=${todo}` : ''}`;
          } else if (authInfo?.roleType === 1) {
            newUrl = `${window.location.origin}/#/admin/authenticationOffice`;
          }
        }
      } else if (window.location.href.includes('/admin/rechargeRecord')) {
        if (type === 'person') {
          newUrl = `${window.location.origin}/#/admin/rechargeRecord`;
        } else if (type === 'office') {
          if (authInfo?.roleType === 1) {
            newUrl = `${window.location.origin}/#/admin/rechargeRecord`;
          } else if (authInfo?.roleType === 2) {
            newUrl = `${window.location.origin}/#/admin/rechargeRecordSystem`;
          } else {
            newUrl = `${window.location.origin}/#/admin/search`;
          }
        }
      } else if (window.location.href.includes('/admin/deductionRecord')) {
        if (type === 'person') {
          newUrl = `${window.location.origin}/#/admin/deductionRecord`;
        } else if (type === 'office') {
          if (authInfo?.roleType === 1) {
            newUrl = `${window.location.origin}/#/admin/deductionRecord`;
          } else if (authInfo?.roleType === 2) {
            newUrl = `${window.location.origin}/#/admin/deductionRecordSystem`;
          } else {
            newUrl = `${window.location.origin}/#/admin/search`;
          }
        }
      } else if (window.location.href.includes('/admin/search/detail')) {
        newUrl = `${window.location.origin}/#/admin/search`;
      } else if (window.location.href.includes('/admin/useManagement')) {
        newUrl = `${window.location.origin}/#/admin/search`;
      } else if (window.location.href.includes('/admin/contractManagement')) {
        newUrl = `${window.location.origin}/#/admin/search`;
      } else if (window.location.href.includes('/admin/balanceManagement')) {
        newUrl = `${window.location.origin}/#/admin/search`;
      }
      if (newUrl && newUrl !== window.location.href) {
        // 避免页面不刷新
        window.location.href = newUrl;
      }
      window.location.reload();
    }
  };

  const goProtocal = () => {
    window.open(`${window.location.origin}/#/protocols`);
  };

  const onPopOpenChange = (open: boolean) => {
    setPopOpen(open);
  };

  return (
    <div className={lessStyle.headerContainer}>
      <div className={lessStyle.innerContainer}>
        <div className={lessStyle.logoContainer}>
          <img src={logo} alt="logo" className={lessStyle.logo} />
          <div className={lessStyle.menuContainer}>
            {menuItems.map((item: any) => (
              <span
                key={item?.key}
                className={`${lessStyle.menuItem} ${activeMenu === item?.key ? lessStyle.active : ''}`}
                onClick={() => handleMenuClick(item)}
              >
                {item?.label}
              </span>
            ))}
          </div>
        </div>
        {
          isEmpty(authInfo) ? (
            <div className={lessStyle.noLoginContainer}>
              <IconBass type="iconicon_denglu" className={lessStyle.icon} />
              <span className={lessStyle.loginText} onClick={() => navigate('/login')}>登录/注册</span>
            </div>
          ) : (
            <div className={lessStyle.userInfoContainer}>
              {showZhanghuyue && (
                <ConfigProvider
                  theme={{
                    components: {
                      Popover: {
                        colorBgElevated: '#fff',
                        boxShadowSecondary: '0px 0px 12px 0px rgba(0,0,0,0.03), 2px 4px 94px 0px rgba(0,0,0,0.03)',
                      },
                    },
                  }}
                >
                  <Popover
                    title={null}
                    open={popOpen}
                    onOpenChange={onPopOpenChange}
                    content={(
                      <div className={lessStyle.zhanghuyuePopover}>
                        <div className={lessStyle.zhanghuyueBG} />
                        <div className={lessStyle.zhanghuyueT1}>账户余额</div>
                        <div className={lessStyle.zhanghuyueBox1}>
                          <div>
                            <span className={lessStyle.zhanghuyueT2}>{accountBalance?.accountBalance ? Math.floor(accountBalance.accountBalance / 100) : 0}</span>
                            <span className={lessStyle.zhanghuyueT3}>元</span>
                          </div>
                          <div className={lessStyle.zhanghuyueBtn1}>
                            <div className={lessStyle.zhanghuyueT4} onClick={showRecharge}>立即充值</div>
                          </div>
                        </div>
                        {/* {
                          (() => {
                            const pools = accountBalance.accountBalancePools || [];
                            const validPools = pools.filter((item: any) => item.accountBalance > 0);

                            // “无数据”：不渲染
                            if (validPools.length === 0) return null;

                            // “只有一条version是30的数据”：不渲染
                            if (
                              validPools.length === 1
                              && String(validPools[0].version) === '30'
                            ) {
                              return null;
                            }

                            return validPools.map((item: any) => (
                              <div key={item.id} className={lessStyle.discountShow}>
                                <span>专享额度</span>
                                <span className={lessStyle.accountBalanceCount}>{Math.floor(item.accountBalance / 100)}</span>
                                <span>元，{priceBalanceMap[item.version]}/人次</span>
                              </div>
                            ));
                          })()
                        } */}
                        <div className={lessStyle.zhanghuyueL1} />
                        <div className={lessStyle.zhanghuyueT5}>余额消耗说明</div>
                        <div className={lessStyle.zhanghuyueBox2}>
                          <div className={`${lessStyle.zhanghuyueItem1} ${lessStyle.gray}`}>
                            <div className={lessStyle.zhanghuyueT6}>查得（有房产）</div>
                            <div className={lessStyle.zhanghuyueT7}>
                              <span>1500元</span>
                              <span style={{ color: '#999999' }}>/次</span>
                            </div>
                          </div>
                          <div className={`${lessStyle.zhanghuyueItem1}`}>
                            <div className={lessStyle.zhanghuyueT6}>查得（无房产）</div>
                            <div className={lessStyle.zhanghuyueT7}>
                              <span>1500元</span>
                              <span style={{ color: '#999999' }}>/次</span>
                            </div>
                          </div>
                          <div className={`${lessStyle.zhanghuyueItem1} ${lessStyle.gray}`}>
                            <div className={lessStyle.zhanghuyueT6}>审核/核查异常</div>
                            <div className={lessStyle.zhanghuyueT7}>
                              <span>免费</span>
                            </div>
                          </div>
                        </div>
                        <div className={lessStyle.zhanghuyueBox3}>
                          <div className={lessStyle.zhanghuyueBtn2} onClick={() => navigate('/admin/rechargeRecord')}>充值记录</div>
                          <div className={lessStyle.zhanghuyueBtn2} style={{ marginLeft: 16 }} onClick={() => navigate('/admin/deductionRecord')}>扣减记录</div>
                        </div>
                      </div>
                    )}
                    trigger={['hover', 'click']}
                  >
                    <div className={lessStyle.zhanghuyueBox}>
                      <div className={lessStyle.zhanghuyueIcon} />
                      <div className={lessStyle.zhanghuyueText}>账户余额</div>
                    </div>
                  </Popover>
                </ConfigProvider>
              )}
              <ConfigProvider
                theme={{
                  components: {
                    Popover: {
                      colorBgElevated: '#fff',
                      boxShadowSecondary: '0px 0px 12px 0px rgba(0,0,0,0.03), 2px 4px 94px 0px rgba(0,0,0,0.03)',
                    },
                  },
                }}
              >
                <Popover
                  title={null}
                  trigger={['click']}
                  content={(
                    <div className={lessStyle.qiehuanzhanghuBox}>
                      <div className={lessStyle.qiehuanzhanghuBoxT1}>切换账户</div>
                      <div className={lessStyle.qiehuanzhanghuBoxItem} onClick={() => switchAccountType('person')}>
                        <div className={lessStyle.userNameIcon}>
                          <div className={lessStyle.avatar}>
                            <img src={defaultPic} alt="" />
                          </div>
                          <div className={`${lessStyle.userName} ${accountType === 'person' ? lessStyle.bold : ''}`}>{authInfo.userName || authInfo?.phoneNo}-个人</div>
                          <Tag color={authInfo.authStatus === 1 ? 'green' : 'default'}><span className={lessStyle.tagBold}>{authInfo.authStatus === 1 ? '已认证' : '未认证'}</span></Tag>
                        </div>
                        {accountType === 'person' && <div className={lessStyle.qiehuanzhanghuBoxI1} />}
                      </div>
                      {authInfo?.officeId && authInfo?.userStatus === 1 && (
                        <div className={lessStyle.qiehuanzhanghuBoxItem} onClick={() => switchAccountType('office')}>
                          <div className={lessStyle.userNameIcon}>
                            <div className={lessStyle.avatar}>
                              <img src={defaultPic} alt="" />
                            </div>
                            <div className={`${lessStyle.userName} ${accountType === 'office' ? lessStyle.bold : ''}`}>{authInfo.officeName || authInfo?.phoneNo}</div>
                            <Tag color={authInfo.reviewStatus === 1 ? 'green' : 'default'}><span className={lessStyle.tagBold}>{['待审核', '审核通过', '驳回'][authInfo.reviewStatus]}</span></Tag>
                          </div>
                          {accountType === 'office' && <div className={lessStyle.qiehuanzhanghuBoxI1} />}
                        </div>
                      )}
                      {(!authInfo?.officeId || authInfo?.userStatus === 0) && !isAccountAuth && (
                        <>
                          <div className={lessStyle.qiehuanzhanghuBoxL1} />
                          <div className={lessStyle.qiehuanzhanghuBoxT2} onClick={() => navigate('/admin/account-auth')}>
                            <div className={lessStyle.qiehuanzhanghuBoxT2Inner}>
                              <div className={lessStyle.qiehuanzhanghuBoxI2} />
                              <span>创建新团队/加入新团队</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                >
                  <div className={lessStyle.userNameIcon}>
                    {accountType === 'person' && (
                      <>
                        <div className={`${lessStyle.userName} ${lessStyle.bold}`}>{authInfo.userName || authInfo?.phoneNo}-个人</div>
                        <Tag color={authInfo.authStatus === 1 ? 'green' : 'default'}><span className={lessStyle.tagBold}>{authInfo.authStatus === 1 ? '已认证' : '未认证'}</span></Tag>
                      </>
                    )}
                    {accountType === 'office' && (
                      <>
                        <div className={`${lessStyle.userName} ${lessStyle.bold}`}>{authInfo.officeName || authInfo?.phoneNo}</div>
                        <Tag color={authInfo.reviewStatus === 1 ? 'green' : 'default'}><span className={lessStyle.tagBold}>{['待审核', '审核通过', '驳回'][authInfo.reviewStatus]}</span></Tag>
                      </>
                    )}
                    <div className={lessStyle.userIcon} />
                  </div>
                </Popover>
              </ConfigProvider>
              <Dropdown menu={{ items: userMenuItems }}>
                <div className={lessStyle.avatar}>
                  <img src={defaultPic} alt="" />
                </div>
              </Dropdown>
            </div>
          )
        }
      </div>
      <Modal title={null} footer={null} centered closable={false} width={800} open={rechargeVisible}>
        <div className={lessStyle.rechargeBox}>
          <div className={lessStyle.rechargeBg} />
          <div className={lessStyle.rechargeVip} />
          <div className={lessStyle.rechargeTitle}>
            <div className={lessStyle.rechargeTitleText}>账户充值</div>
            <div className={lessStyle.rechargeTitleIcon} onClick={() => setRechargeVisible(false)} />
          </div>
          {rechargeSuccess ? (
            <>
              <div className={lessStyle.rechargeBox1} />
              <div className={lessStyle.rechargeBox3}>
                <div className={lessStyle.rechargeBox3I1} />
                <div className={lessStyle.rechargeBox3T1}>您已成功付款 {activeProdDetail?.price} 元</div>
                <div className={lessStyle.rechargeBox3T2}>
                  <span>{count} 秒后将为您自动跳转至查询列表</span>
                  <span className={lessStyle.rechargeBox3T3} onClick={goSearch}>立即跳转</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={lessStyle.rechargeBox1}>
                {prodList.map((item: any) => (
                  <div key={item.key} className={`${lessStyle.rechargeBox1ItemWrapper}`}>
                    <div className={`${lessStyle.rechargeBox1ItemWrapperInner}`}>
                      <div className={`${lessStyle.rechargeBox1Item} ${item.key === activeProd ? lessStyle.active : ''}`} onClick={() => setActiveProd(item.key)}>
                        <div className={lessStyle.rechargeBox1ItemT1}>{item.name}</div>
                        <div className={lessStyle.rechargeBox1ItemT2}>
                          <span style={{ fontSize: 16 }}>￥</span>
                          <span>{item.price}</span>
                        </div>
                        <div className={lessStyle.rechargeBox1ItemT3}>{item.give ? `赠送${item.give}元` : ' '}</div>
                        <div className={lessStyle.rechargeBox1ItemT4}>低至{item.per}元/人次</div>
                      </div>
                    </div>
                    {item.key === 'p50000' && <div className={lessStyle.rechargeBox1ItemI1} />}
                  </div>
                ))}
              </div>
              <div className={lessStyle.rechargeBox2}>
                <div className={lessStyle.rechargeBox2Inner}>
                  {!orderDetail?.qrCodePath
                    ? (
                      <div className={lessStyle.rechargeBox2QREmpty}>
                        <LoadingOutlined />
                      </div>
                    )
                    : <img src={orderDetail?.qrCodePath} alt="支付二维码" className={lessStyle.rechargeBox2QR} />}
                  <div>
                    <div className={lessStyle.rechargeBox2P1}>
                      <div className={lessStyle.rechargeBox2T1}>实付</div>
                      <div className={lessStyle.rechargeBox2T2}>{activeProdDetail?.price}</div>
                      <div className={lessStyle.rechargeBox2T1}>元</div>
                      <div className={lessStyle.rechargeBox2L1} />
                      <div className={lessStyle.rechargeBox2T3}>账户充值{activeProdDetail?.price ? activeProdDetail.price + activeProdDetail.give : 0}元</div>
                    </div>
                    <div className={lessStyle.rechargeBox2P2}>
                      <div className={lessStyle.rechargeBox2I1} />
                      <div className={lessStyle.rechargeBox2T4}>支付宝扫码支付</div>
                    </div>
                    <div className={lessStyle.rechargeBox2P3}>
                      <div className={lessStyle.rechargeBox2T5}>支付视为同意</div>
                      <div className={lessStyle.rechargeBox2T6} onClick={goProtocal}>《iLaw不动产服务协议》</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}
